import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme, Typography } from '@material-ui/core';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { FormGroup } from '../../components/FormGroup';
import { TextField } from '../../components/TextField';
import { Button } from '../../components/Button';
import { usePartner } from '../../hooks/usePartner';
import { api } from '../../api';
import { ResPartnerWriteRequestData } from '../../api/resPartnerWrite';
import { useLoading } from '../../units/loading';
import { useAlert } from '../../units/alert';
import { StatusFalseError } from '../../api/error/StatusFalseError';

type EditMemberPageProps = {};

EditMemberPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function EditMemberPage(props: EditMemberPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const { partner, isLoading: isPartnerLoading } = usePartner();
    const { setIsLoading } = useLoading();
    const alert = useAlert();
    const [formData, setFormData] = useState<ResPartnerWriteRequestData>({
        login: '',
        id: '',
        contact_address: '',
        name: '',
        phone: '',
    });

    useEffect(() => {
        setIsLoading(isPartnerLoading);
    }, [isPartnerLoading]);

    useEffect(() => {
        if (partner) {
            setFormData((data) => ({
                ...data,
                login: partner.email,
                id: partner.id,
                contact_address: partner.contact_address,
                name: partner.name,
                phone: partner.phone,
            }));
        }
    }, [partner]);

    function handleSubmitClick() {
        setIsLoading(true);
        api.resPartnerWrite(formData)
            .then(() => {
                setIsLoading(false);
                alert.show({
                    type: 'success',
                    title: '操作成功',
                    message: '已成功修改基本資料',
                });
                history.replace('/member/action');
            })
            .catch(async (e) => {
                setIsLoading(false);
                if (e instanceof StatusFalseError) {
                    const errorData = await e.response.json();
                    alert.show({
                        type: 'error',
                        title: '錯誤',
                        message: errorData.msg,
                    });
                }
            });
    }

    return (
        <Page>
            <BackAppBar title="修改基本資料" onBackClick={() => history.replace('/member/action')} />
            <PageBody>
                <FormGroup
                    title="帳號"
                    actionElement={(
                        <div style={{ display: 'flex', flexDirection: 'column', marginRight: 8 }}>
                            <Typography variant="caption"><span style={{ color: '#ef5350' }}> * </span>為必填項目</Typography>
                            <Typography variant="caption">請輸入正確資訊以提供完善服務</Typography>
                        </div>
                    )}
                >
                    <TextField
                        label="帳號(E-mail)"
                        value={formData.login}
                        disabled
                    />
                </FormGroup>
                <FormGroup title="單位資訊">
                    <TextField
                        label="地址"
                        value={formData.contact_address}
                        onChange={(e) => setFormData({
                            ...formData,
                            contact_address: e.target.value,
                        })}
                    />
                </FormGroup>
                <FormGroup title="基本資料">
                    <TextField
                        label="姓名"
                        value={formData.name}
                        onChange={(e) => setFormData({
                            ...formData,
                            name: e.target.value,
                        })}
                    />
                    <TextField
                        label="電話/手機"
                        value={formData.phone}
                        onChange={(e) => setFormData({
                            ...formData,
                            phone: e.target.value,
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Button onClick={handleSubmitClick}>送出修改</Button>
                </FormGroup>
            </PageBody>
        </Page>
    );
}

export { EditMemberPage };
